import { jsx as _jsx } from "react/jsx-runtime";
import lottie from 'lottie-web';
import { useEffect, useRef } from 'react';
export var LottieAnimation = function (_a) {
  var data = _a.data,
    url = _a.url,
    _b = _a.loop,
    loop = _b === void 0 ? false : _b;
  var ref = useRef(null);
  var animation;
  useEffect(function () {
    if (data && ref.current) {
      animation = lottie.loadAnimation({
        animationData: data,
        container: ref.current,
        renderer: 'svg',
        loop: loop
      });
    }
    if (url && ref.current) {
      animation = lottie.loadAnimation({
        path: url,
        container: ref.current,
        renderer: 'svg',
        loop: loop
      });
    }
    return function () {
      return animation.destroy();
    };
  }, [data, url, loop]);
  return _jsx("div", {
    "data-cy-label": "lottie-animation",
    ref: ref
  });
};